// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27white%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.off-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.off-form__banner {
  padding: 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
}

.off-form__banner--error {
  background-color: rgba(179, 43, 43, 0.15);
  border: 1px solid #b32b2b;
  color: #ff6b6b;
}

.off-form__section {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 28px;
}

.off-form__section-title {
  font-size: 18px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 24px;
  border-left: 3px solid #48d1cc;
  padding-left: 12px;
  color: #48d1cc;
}

.off-form__group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.off-form__group:last-child {
  margin-bottom: 0;
}

.off-form__row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.off-form__group--half {
  flex: 1 1;
  min-width: 220px;
}

.off-form__group--third {
  flex: 1 1;
  min-width: 140px;
}

.off-form__group--two-thirds {
  flex: 2 1;
  min-width: 280px;
}

.off-form__label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.off-form__required {
  color: #ff6b6b;
}

.off-form__input {
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #ffffff;
  padding: 12px 16px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}

/* Remove native spin buttons for number inputs */
.off-form__input::-webkit-outer-spin-button,
.off-form__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.off-form__input[type=number] {
  appearance: textfield;
}

.off-form__input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.off-form__input:focus {
  border-color: #3bb3ae;
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);
}

.off-form__input--error {
  border-color: #b32b2b;
  background-color: rgba(179, 43, 43, 0.05);
}

.off-form__input--textarea {
  min-height: 120px;
  resize: vertical;
  line-height: 1.5;
}

.off-form__input--textarea-small {
  min-height: 80px;
  resize: vertical;
}

select.off-form__input {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 40px;
}

select.off-form__input option {
  background-color: #0e1b1b;
  color: #fff;
}

.off-form__hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
}

.off-form__error-text {
  font-size: 12px;
  color: #ff6b6b;
  font-weight: 500;
}

/* Tags styles */
.off-form__tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 8px 12px;
  align-items: center;
  min-height: 46px;
  box-sizing: border-box;
}

.off-form__tag {
  background-color: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48d1cc;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.off-form__tag-remove {
  background: none;
  border: none;
  color: #48d1cc;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
}

.off-form__tag-remove:hover {
  color: #fff;
}

.off-form__tags-input {
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  flex: 1 1;
  min-width: 150px;
  padding: 4px 0;
  font-family: inherit;
}

.off-form__tags-input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

/* Radio buttons styles */
.off-form__radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 4px;
}

.off-form__radio-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.off-form__radio-label input[type="radio"] {
  accent-color: #3bb3ae;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Nested fields */
.off-form__nested-fields {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 20px;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.off-form__nested-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Image Uploads */
.off-form__image-upload-wrapper {
  background-color: rgba(255, 255, 255, 0.03);
  border: 1.5px dashed rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  transition: border-color 0.2s;
}

.off-form__image-upload-wrapper:hover {
  border-color: rgba(72, 209, 204, 0.45);
}

.off-form__upload-btn {
  background-color: rgba(72, 209, 204, 0.1);
  border: 1px solid rgba(72, 209, 204, 0.3);
  border-radius: 30px;
  color: #48d1cc;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 24px;
  transition: all 0.2s ease;
}

.off-form__upload-btn:hover {
  background-color: #3bb3ae;
  color: #071414;
}

.off-form__image-preview-box {
  position: relative;
  width: 100%;
  max-width: 320px;
  border-radius: 8px;
  overflow: hidden;
}

.off-form__image-preview {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

.off-form__image-clear-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.off-form__image-clear-btn:hover {
  background-color: rgba(0, 0, 0, 0.9);
}

/* Gallery styles */
.off-form__gallery-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.off-form__gallery-item {
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.off-form__gallery-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.off-form__gallery-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
}

.off-form__gallery-remove:hover {
  background: rgba(0, 0, 0, 0.9);
}

.off-form__gallery-add-btn {
  width: 90px;
  height: 90px;
  background-color: rgba(255, 255, 255, 0.03);
  border: 1.5px dashed rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.2s ease;
}

.off-form__gallery-add-btn:hover {
  border-color: rgba(72, 209, 204, 0.35);
  color: #48d1cc;
  background-color: rgba(72, 209, 204, 0.05);
}

/* Actions styling */
.off-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 12px;
}

.off-form__btn {
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 32px;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
}

.off-form__btn--cancel {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.85);
}

.off-form__btn--cancel:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
  color: #fff;
}

.off-form__btn--submit {
  background-color: #3bb3ae;
  border: none;
  color: #071414;
}

.off-form__btn--submit:hover {
  opacity: 0.9;
  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.3);
}

@media (max-width: 768px) {
  .off-form__section {
    padding: 20px;
  }

  .off-form__actions {
    flex-direction: column-reverse;
  }

  .off-form__btn {
    width: 100%;
  }
}

/* Custom Dropdown Styling */
.custom-dropdown-container {
  position: relative;
  width: 100%;
}

.custom-dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.custom-dropdown-selected.active {
  border-color: #3bb3ae;
  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);
}

.custom-dropdown-options {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 10px;
  border: 1px solid rgba(72, 209, 204, 0.25);
  background-color: #071414;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  padding: 6px 0;
  box-sizing: border-box;
}

.custom-dropdown-option {
  padding: 10px 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;
}

.custom-dropdown-option:hover {
  background-color: rgba(72, 209, 204, 0.1);
  color: #ffffff;
}

.custom-dropdown-option.selected {
  background-color: rgba(72, 209, 204, 0.15);
  color: #48d1cc;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Components/Offerings/OfferingForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAsN;EACtN,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,2CAA2C;EAC3C,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".off-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.off-form__banner {\n  padding: 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.off-form__banner--error {\n  background-color: rgba(179, 43, 43, 0.15);\n  border: 1px solid #b32b2b;\n  color: #ff6b6b;\n}\n\n.off-form__section {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  padding: 28px;\n}\n\n.off-form__section-title {\n  font-size: 18px;\n  font-weight: 700;\n  margin-top: 0;\n  margin-bottom: 24px;\n  border-left: 3px solid #48d1cc;\n  padding-left: 12px;\n  color: #48d1cc;\n}\n\n.off-form__group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.off-form__group:last-child {\n  margin-bottom: 0;\n}\n\n.off-form__row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.off-form__group--half {\n  flex: 1;\n  min-width: 220px;\n}\n\n.off-form__group--third {\n  flex: 1;\n  min-width: 140px;\n}\n\n.off-form__group--two-thirds {\n  flex: 2;\n  min-width: 280px;\n}\n\n.off-form__label {\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.off-form__required {\n  color: #ff6b6b;\n}\n\n.off-form__input {\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #ffffff;\n  padding: 12px 16px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n/* Remove native spin buttons for number inputs */\n.off-form__input::-webkit-outer-spin-button,\n.off-form__input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.off-form__input[type=number] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.off-form__input::placeholder {\n  color: rgba(255, 255, 255, 0.35);\n}\n\n.off-form__input:focus {\n  border-color: #3bb3ae;\n  background-color: rgba(255, 255, 255, 0.07);\n  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);\n}\n\n.off-form__input--error {\n  border-color: #b32b2b;\n  background-color: rgba(179, 43, 43, 0.05);\n}\n\n.off-form__input--textarea {\n  min-height: 120px;\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.off-form__input--textarea-small {\n  min-height: 80px;\n  resize: vertical;\n}\n\nselect.off-form__input {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 40px;\n}\n\nselect.off-form__input option {\n  background-color: #0e1b1b;\n  color: #fff;\n}\n\n.off-form__hint {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.off-form__error-text {\n  font-size: 12px;\n  color: #ff6b6b;\n  font-weight: 500;\n}\n\n/* Tags styles */\n.off-form__tags-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 8px 12px;\n  align-items: center;\n  min-height: 46px;\n  box-sizing: border-box;\n}\n\n.off-form__tag {\n  background-color: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48d1cc;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 13px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.off-form__tag-remove {\n  background: none;\n  border: none;\n  color: #48d1cc;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n}\n\n.off-form__tag-remove:hover {\n  color: #fff;\n}\n\n.off-form__tags-input {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 14px;\n  flex: 1;\n  min-width: 150px;\n  padding: 4px 0;\n  font-family: inherit;\n}\n\n.off-form__tags-input::placeholder {\n  color: rgba(255, 255, 255, 0.35);\n}\n\n/* Radio buttons styles */\n.off-form__radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.off-form__radio-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  user-select: none;\n}\n\n.off-form__radio-label input[type=\"radio\"] {\n  accent-color: #3bb3ae;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Nested fields */\n.off-form__nested-fields {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 20px;\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.off-form__nested-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Image Uploads */\n.off-form__image-upload-wrapper {\n  background-color: rgba(255, 255, 255, 0.03);\n  border: 1.5px dashed rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n  transition: border-color 0.2s;\n}\n\n.off-form__image-upload-wrapper:hover {\n  border-color: rgba(72, 209, 204, 0.45);\n}\n\n.off-form__upload-btn {\n  background-color: rgba(72, 209, 204, 0.1);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  border-radius: 30px;\n  color: #48d1cc;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 24px;\n  transition: all 0.2s ease;\n}\n\n.off-form__upload-btn:hover {\n  background-color: #3bb3ae;\n  color: #071414;\n}\n\n.off-form__image-preview-box {\n  position: relative;\n  width: 100%;\n  max-width: 320px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.off-form__image-preview {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  display: block;\n}\n\n.off-form__image-clear-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.off-form__image-clear-btn:hover {\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n/* Gallery styles */\n.off-form__gallery-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.off-form__gallery-item {\n  position: relative;\n  width: 90px;\n  height: 90px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.off-form__gallery-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.off-form__gallery-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  color: #fff;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.off-form__gallery-remove:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n.off-form__gallery-add-btn {\n  width: 90px;\n  height: 90px;\n  background-color: rgba(255, 255, 255, 0.03);\n  border: 1.5px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.5);\n  transition: all 0.2s ease;\n}\n\n.off-form__gallery-add-btn:hover {\n  border-color: rgba(72, 209, 204, 0.35);\n  color: #48d1cc;\n  background-color: rgba(72, 209, 204, 0.05);\n}\n\n/* Actions styling */\n.off-form__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.off-form__btn {\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 12px 32px;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  min-height: 44px;\n}\n\n.off-form__btn--cancel {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.off-form__btn--cancel:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #fff;\n}\n\n.off-form__btn--submit {\n  background-color: #3bb3ae;\n  border: none;\n  color: #071414;\n}\n\n.off-form__btn--submit:hover {\n  opacity: 0.9;\n  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.3);\n}\n\n@media (max-width: 768px) {\n  .off-form__section {\n    padding: 20px;\n  }\n\n  .off-form__actions {\n    flex-direction: column-reverse;\n  }\n\n  .off-form__btn {\n    width: 100%;\n  }\n}\n\n/* Custom Dropdown Styling */\n.custom-dropdown-container {\n  position: relative;\n  width: 100%;\n}\n\n.custom-dropdown-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.custom-dropdown-selected.active {\n  border-color: #3bb3ae;\n  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);\n}\n\n.custom-dropdown-options {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 220px;\n  overflow-y: auto;\n  border-radius: 10px;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  background-color: #071414;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  padding: 6px 0;\n  box-sizing: border-box;\n}\n\n.custom-dropdown-option {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.custom-dropdown-option:hover {\n  background-color: rgba(72, 209, 204, 0.1);\n  color: #ffffff;\n}\n\n.custom-dropdown-option.selected {\n  background-color: rgba(72, 209, 204, 0.15);\n  color: #48d1cc;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
